import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import user from '../Img/user.png';
import { toast } from "react-toastify";

const Header = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [isQuickCreateOpen, setQuickCreateOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
  const quickCreateRef = useRef(null);
  const profileMenuRef = useRef(null);
  const [isOfferingOpen, setIsOfferingOpen] = useState(false);

  const navigate = useNavigate();

  // Function to toggle Quick Create menu
  const toggleQuickCreate = () => {
    setQuickCreateOpen(prevState => !prevState);
    setProfileMenuOpen(false); // Close profile menu if open
  };

  // Function to toggle Profile menu
  const toggleProfileMenu = () => {
    setProfileMenuOpen(prevState => !prevState);
    setQuickCreateOpen(false); // Close quick create menu if open
  };

  // ✅ Logout handler
  const handleLogout = () => {
    localStorage.removeItem("accessToken"); // clear token
    toast.success("Logged out successfully!");
    navigate("/login", { replace: true }); // redirect to login
  };

  // Close menus if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        quickCreateRef.current && !quickCreateRef.current.contains(event.target) &&
        !event.target.closest('.quick-create')
      ) {
        setQuickCreateOpen(false);
      }
      if (
        profileMenuRef.current && !profileMenuRef.current.contains(event.target) &&
        !event.target.closest('.header-profile')
      ) {
        setProfileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className={`header ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="header-list hamburger-search">
          <div className="header-hamburger" onClick={toggleSidebar}>
            <i className="fas fa-bars"></i>
          </div>
          <div className="search-container">
            <input type="text" placeholder="Search..." />
            <i className="fas fa-search search-icon"></i>
          </div>
        </div>
        <div className="header-list header-list2">
          <div className="notification">
            <i className="fa-regular fa-bell"></i>
          </div>
          <div className="header-profile" onClick={toggleProfileMenu}>
            <div className="profile-img">
              <img src={user} alt="User Profile" />
            </div>
            {isProfileMenuOpen && (
              <div className="profile-menu" ref={profileMenuRef}>
                <ul>
                  {/* <li><i className="fa fa-user"></i> Profile</li> */}
                  <li onClick={handleLogout}>
                    <i className="fa fa-sign-out-alt"></i> Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
